import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IStyleProps } from "./interfaces";

export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: calc(100% - 60px - 236px);
    ${p => p.isEaster && css`
        margin-top: 115px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 42px;
        height: calc(100% - 60px - 180px - 122px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 250px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 64px;
    left: -9px;
    right: -6px;
    bottom: 206px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${115 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${247 - padding}px;
    z-index: -1;
`;

export const SolfaLadderWrapper = styled.div<IStyleProps>`
    &.Completed {
        opacity: 0.4;
        pointer-events: none;
        transition: 2s;
    }
    ${p =>
        p.isLow
            ? css`
                  width: 680px;
                  margin: auto;
                  margin-top: 30px;
              `
            : undefined}
`;

export const AssetWrapper = styled.div`
    position: absolute;
    bottom: -10px;
    pointer-events: none;

    img {
        width: 1280px;
    }
`;
